import { ThemeOptions } from '@material-ui/core';
import logo from './assets/img/logo.svg';
import favicon from './assets/img/favicon.ico';
import appleIcon from './assets/img/icon-256x256.png';
import manifest from './manifest.webmanifest';

export const overrides: ThemeOptions = {
  palette: {
    type: 'dark',
    primary: {
      main: '#128958',
    },
  },
  meta: {
    propertyName: 'Global Risk Management',
    propertyOwner: 'Global Risk Management',
    propertyDesc: 'TBC',
    logo,
    favicon,
    manifest,
    appleIcon,
    googAnal: 'UA-206620876-1', // SIMON'S TESTING ACC TRACKING ID
    twitterId: undefined,
    policies: [],
    loginTerms: 'NULL',
  },
};

export default overrides;
